// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"NoResults__srOnly--Y8SX0","hiddenInput":"NoResults__hiddenInput--3ucCZ","root":"NoResults__root--1kX1_","emoji":"NoResults__emoji--2oVCD"};